import { zodResolver } from "@hookform/resolvers/zod";
import { useForm, Controller } from "react-hook-form";
import { schema } from "./schema";

export const IndexHook = ({ options, handleSubmitModalFilter, filterData }) => {
	const parameterDefault = options?.parametersFilter?.[0];
	const value = parameterDefault?.value;
	const label = parameterDefault?.label;

	const {
		handleSubmit,
		register,
		watch,
		setFocus,
		setValue,
		formState: { errors, isSubmitting },
		control,
	} = useForm({
		mode: "onSubmit",
		resolver: zodResolver(schema),
		defaultValues: {
			param: { value, label },
			paramValue: "",
			active: true,
		},
	});

	const paramSelected = watch("param");

	const handleOnSubmit = async (data) => {
		const hasActive = options.hasActive;

		const filteredObject = {};

		Object.entries(data).forEach(([key, value]) => {
			if (value !== undefined && value !== null && value !== "") {
				if (key === "param") {
					filteredObject["param"] = {
						label: "Parametro", // Adiciona o label
						value: value.label, // Mantém o valor
					};
				} else if (key === "paramValue") {
					filteredObject["paramValue"] = {
						label: "Valor:", // Adiciona o label
						value: value, // Valor formatado
					};
				} else if (key === "active") {
					if (hasActive) {
						filteredObject["active"] = {
							label: "Ativo", // Adiciona o label
							value: value ? "SIM" : "NAO", // Valor formatado
						};
					}
				} else {
					filteredObject[key] = {
						label: key, // A chave pode ser o label, ou você pode customizar isso
						value: value,
					};
				}
			}
		});

		await handleSubmitModalFilter(filteredObject, data);
	};

	return {
		errors,
		isSubmitting,
		register,
		handleSubmit,
		handleOnSubmit,
		paramSelected,
		setFocus,
		control,
		Controller,
		setValue,
	};
};
